import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NiceSelectModule } from "ng-nice-select";

import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';

import { UsersRoutingModule } from '@teem/users-module/users-routing.module';
import { UsersComponent } from '@teem/users-module/users.component';
import { AddUserModalComponent } from '@teem/users-module/modals/add-user-modal/add-user-modal.component';
import { EditUserModalComponent } from '@teem/users-module/modals/edit-user-modal/edit-user-modal.component';

@NgModule({
  declarations: [
    UsersComponent,
    AddUserModalComponent,
    EditUserModalComponent
  ],
  entryComponents: [
    AddUserModalComponent,
    EditUserModalComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UsersRoutingModule,
    NiceSelectModule,
    SharedModule,
    CoreModule
  ]
})
export class UsersModule { }
